import { Component } from '@angular/core'
import { CandidateListService } from '@employer/app/modules/jobs/services/candidate-list.service'
import { TranslateModule } from '@ngx-translate/core'
import { APPLICATION_STATE, SharedLibModule } from 'shared-lib'

const EXCLUDED_SWIMLANES = [APPLICATION_STATE.UNRESPONSIVE, APPLICATION_STATE.NOT_INTERESTED, APPLICATION_STATE.WITHDRAWN]

@Component({
  selector: 'swimlane-flow-header',
  standalone: true,
  imports: [TranslateModule, SharedLibModule],
  template: `
    <div>
      <h3 class="e11-text-skin-complimentary">{{ 'Swimlane Advancement Flow' | translate }}</h3>
      <p class="e11-text-sm e11-mb-4">
        {{
          'Swimlane changes configured as part of automation will only move candidates forward in the workflow. Settings that might move candidates backward will be ignored.'
            | translate
        }}
      </p>
      <div class="e11-flex e11-overflow-x-auto e11-gap-2 e11-items-center">
        @for (swimlane of swimlaneFlow; track swimlane; let isLast = $last; let isFirst = $first) {
        <div
          class="e11-w-24 e11-min-w-[6rem] e11-flex e11-items-center e11-justify-center e11-gap-2 e11-bg-skin-complimentary/10 e11-border e11-border-skin-complimentary e11-px-4 e11-h-8 e11-rounded-2xl"
        >
          <p class="e11-mb-0 e11-text-skin-complimentary e11-text-xs">{{ swimlane | applicationState }}</p>
        </div>
        @if ( !isLast) {
        <span class="material-symbols-outlined e11-text-skin-complimentary e11-rotate-90 e11-text-sm"> arrow_warm_up </span>

        } }
      </div>
    </div>
  `,
})
export class SwimlaneFlowHeaderComponent {
  swimlaneFlow = CandidateListService.getOrderedApplicationStates().filter(swimlane => !EXCLUDED_SWIMLANES.includes(swimlane))
}
